import { STRIPE_SUBSCRIPTION_RETURN_PATH_KEY } from '@/storage/keys';
import {
  readSessionJsonItem,
  removeSessionItem,
  writeSessionJsonItem,
} from '@/storage/imperativeJsonStore';
import { getLastAuthenticatedRoute, isSafeRedirectPath } from '@/utils/authRedirect';

const FALLBACK_RETURN_PATH = '/';
const CHECKOUT_FLOW_PATH_PREFIXES = ['/subscriptions', '/stripe/subscribed-callback'];

const normalizePath = (path) => (Array.isArray(path) ? path[0] : path);

export function isSafeSubscriptionReturnPath(path) {
  const candidate = normalizePath(path);
  if (!isSafeRedirectPath(candidate)) {
    return false;
  }

  const trimmed = candidate.trim();
  return !CHECKOUT_FLOW_PATH_PREFIXES.some((prefix) => trimmed.startsWith(prefix));
}

export function currentHashRoutePath(windowRef = typeof window === 'undefined' ? null : window) {
  const hash = windowRef?.location?.hash || '';
  const path = hash.startsWith('#') ? hash.slice(1) : hash;

  return path.startsWith('/') ? path : null;
}

export function rememberSubscriptionReturnPath(path = currentHashRoutePath()) {
  if (!isSafeSubscriptionReturnPath(path)) {
    return;
  }

  writeSessionJsonItem(STRIPE_SUBSCRIPTION_RETURN_PATH_KEY, path.trim());
}

export function getSubscriptionReturnPath(fallback = FALLBACK_RETURN_PATH) {
  const stored = readSessionJsonItem(STRIPE_SUBSCRIPTION_RETURN_PATH_KEY, null);
  if (isSafeSubscriptionReturnPath(stored)) {
    return stored.trim();
  }

  const lastAuthenticated = getLastAuthenticatedRoute();
  if (isSafeSubscriptionReturnPath(lastAuthenticated)) {
    return lastAuthenticated.trim();
  }

  return fallback;
}

export function forgetSubscriptionReturnPath() {
  removeSessionItem(STRIPE_SUBSCRIPTION_RETURN_PATH_KEY);
}
